/* BBS Considered 1.0 — native Shopify interactions, progressively enhanced. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const route = (path) =>
    (window.Shopify?.routes?.root || document.body.dataset.rootUrl || '/') + path;
  const announce = (message) => {
    const node = $('[data-global-status]');
    if (node) node.textContent = message;
  };
  const showError = (node, message) => {
    if (node) {
      node.textContent = message;
      node.hidden = false;
    }
    announce(message);
  };
  const escapeSelector = (value) => CSS.escape(String(value));
  const galleryControllers = new WeakMap();
  const productControllers = new WeakMap();
  const initializedSearch = new WeakSet();
  const initializedRecommendations = new WeakSet();
  const returnFocus = new WeakMap();
  let cartBusy = false;

  function openDialog(dialog, trigger = document.activeElement) {
    if (!dialog) return;
    if (dialog.open && dialog.matches(':modal')) return;
    if (dialog.open) dialog.close();
    returnFocus.set(dialog, trigger);
    dialog.showModal();
  }
  function closeDialog(dialog) {
    if (dialog?.open) dialog.close();
  }
  document.addEventListener(
    'close',
    (event) => {
      const trigger = returnFocus.get(event.target);
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      returnFocus.delete(event.target);
    },
    true,
  );
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-dialog-close]');
    if (close) closeDialog(close.closest('dialog'));
    const trigger = event.target.closest('[data-dialog-open]');
    if (trigger) openDialog(document.getElementById(trigger.dataset.dialogOpen), trigger);
    if (event.target instanceof HTMLDialogElement && event.target.matches(':modal')) {
      const rect = event.target.getBoundingClientRect();
      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      )
        closeDialog(event.target);
    }
    $$('.desktop-navigation details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
    $$('.facet[open]').forEach((details) => {
      if (!details.contains(event.target) && !event.target.closest('[data-filter-dialog]'))
        details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      $$('.desktop-navigation details[open]').forEach((details) => {
        details.open = false;
        $('summary', details)?.focus();
      });
      $$('.facet[open]').forEach((details) => {
        details.open = false;
      });
    }
  });
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (details.matches('.desktop-navigation details') && details.open) {
        $$('.desktop-navigation details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      }
    },
    true,
  );
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button || button.disabled) return;
    const input = $('input', button.closest('[data-qty]'));
    if (!input || input.disabled) return;
    const minimum = Number(input.min || 1),
      maximum = input.max ? Number(input.max) : Infinity,
      step = Number(input.step || 1);
    const value = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : minimum;
    input.value = Math.min(
      maximum,
      Math.max(minimum, value + (button.hasAttribute('data-quantity-plus') ? step : -step)),
    );
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function initGallery(gallery) {
    if (galleryControllers.has(gallery)) return;
    const slides = $$('[data-gallery-slide]', gallery),
      thumbs = $$('[data-gallery-thumb]', gallery);
    const stage = $('[data-gallery-stage]', gallery),
      dialog = $('[data-gallery-dialog]', gallery);
    const imageIndices = slides
      .map((slide, i) => (slide.dataset.mediaType === 'image' ? i : -1))
      .filter((i) => i >= 0);
    let index = Math.max(
        0,
        slides.findIndex((slide) => !slide.hidden),
      ),
      swipeStart = null,
      skipZoomUntil = 0;
    function pauseMedia(slide) {
      $$('video', slide).forEach((video) => video.pause());
      $$('model-viewer', slide).forEach((model) => model.pause?.());
      $$('iframe', slide).forEach((frame) => {
        try {
          const url = new URL(frame.src);
          if (/(^|\.)youtube(-nocookie)?\.com$/.test(url.hostname))
            frame.contentWindow?.postMessage(
              JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
              url.origin,
            );
          if (url.hostname === 'player.vimeo.com')
            frame.contentWindow?.postMessage({ method: 'pause' }, url.origin);
        } catch (_) {
          /* An uninitialised media frame has nothing to pause. */
        }
      });
    }
    function syncZoom() {
      const source = $('img', slides[index]);
      if (!source || slides[index].dataset.mediaType !== 'image') return;
      const image = $('[data-zoom-image]', dialog);
      image.src = source.dataset.zoomSrc || source.currentSrc || source.src;
      image.alt = source.alt;
      $('[data-zoom-stage]', dialog).classList.remove('is-zoomed');
      $('[data-zoom-count]', dialog).textContent =
        `Image ${imageIndices.indexOf(index) + 1} of ${imageIndices.length}`;
      $$('[data-zoom-prev], [data-zoom-next]', dialog).forEach((button) => {
        button.hidden = imageIndices.length < 2;
      });
    }
    function show(next, scrollThumb = false) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        if (i !== index) pauseMedia(slide);
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const count = $('[data-gallery-count]', gallery);
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      if (scrollThumb && thumbs[index]) {
        const strip = thumbs[index].parentElement,
          thumb = thumbs[index];
        strip.scrollTo({
          left: Math.max(
            0,
            thumb.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2,
          ),
          behavior: 'auto',
        });
      }
      if (dialog?.open) syncZoom();
    }
    function moveImage(direction) {
      if (!imageIndices.length) return;
      const position = imageIndices.indexOf(index);
      show(imageIndices[(position + direction + imageIndices.length) % imageIndices.length], true);
    }
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) show(Number(thumb.dataset.galleryThumb), true);
      if (event.target.closest('[data-gallery-prev]')) show(index - 1, true);
      if (event.target.closest('[data-gallery-next]')) show(index + 1, true);
      if (
        event.target.closest('[data-open-zoom]') &&
        Date.now() > skipZoomUntil &&
        imageIndices.includes(index)
      ) {
        syncZoom();
        openDialog(dialog, event.target.closest('button'));
      }
      if (event.target.closest('[data-zoom-prev]')) moveImage(-1);
      if (event.target.closest('[data-zoom-next]')) moveImage(1);
      if (event.target.matches('[data-zoom-image]'))
        $('[data-zoom-stage]', dialog).classList.toggle('is-zoomed');
    });
    gallery.addEventListener('keydown', (event) => {
      if (
        !['ArrowLeft', 'ArrowRight'].includes(event.key) ||
        event.target.closest('video, iframe, model-viewer')
      )
        return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      if (dialog?.open) moveImage(direction);
      else show(index + direction, true);
    });
    stage?.addEventListener('pointerdown', (event) => {
      if (slides[index]?.dataset.mediaType === 'image' && event.isPrimary && event.button === 0)
        swipeStart = { x: event.clientX, y: event.clientY };
    });
    stage?.addEventListener('pointerup', (event) => {
      if (!swipeStart) return;
      const x = event.clientX - swipeStart.x,
        y = event.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.2) {
        skipZoomUntil = Date.now() + 400;
        show(index + (x < 0 ? 1 : -1), true);
      }
    });
    stage?.addEventListener('pointercancel', () => {
      swipeStart = null;
    });
    galleryControllers.set(gallery, {
      showMedia: (id) => {
        const i = slides.findIndex((slide) => slide.dataset.mediaId === String(id));
        if (i >= 0) show(i, true);
      },
      pauseAll: () => slides.forEach(pauseMedia),
    });
    show(index);
  }

  function initProduct(product) {
    if (productControllers.has(product)) return;
    let abort = null,
      generation = 0;
    const state = { busy: false, updateSticky: null };
    productControllers.set(product, state);
    const sticky = $('[data-sticky-purchase]', product);
    function updateSticky() {
      const buy = $('[data-product-buy]', product),
        button = $('[data-add-to-cart]', buy),
        stickyButton = $('[data-sticky-add]', sticky || product);
      if (stickyButton && button) {
        stickyButton.disabled = button.disabled;
        stickyButton.innerHTML = button.innerHTML;
      }
      const price = $('[data-sticky-price]', product),
        sourcePrice = $('.current-price', buy);
      if (price) price.textContent = sourcePrice?.textContent || 'Unavailable';
      if (sticky && button) {
        const rect = button.getBoundingClientRect();
        sticky.hidden = rect.bottom >= 0 || rect.width === 0;
      }
    }
    state.updateSticky = updateSticky;
    window.addEventListener(
      'scroll',
      () => {
        if (product.isConnected) updateSticky();
      },
      { passive: true },
    );
    window.addEventListener(
      'resize',
      () => {
        if (product.isConnected) updateSticky();
      },
      { passive: true },
    );
    updateSticky();
    product.addEventListener('click', (event) => {
      if (event.target.closest('[data-sticky-add]')) {
        const form = $('[data-product-form]', product),
          button = $('[data-add-to-cart]', form);
        if (form && button && !button.disabled) form.requestSubmit(button);
      }
    });
    product.addEventListener('change', async (event) => {
      if (!event.target.matches('[data-option-id], [data-selling-plan]')) return;
      const buy = $('[data-product-buy]', product),
        changed = event.target;
      const focusId = changed.id,
        quantity = $('[name="quantity"]', buy)?.value || '1';
      const selected = $$('[data-option-id]:checked', buy).map((input) => input.dataset.optionId);
      const otherProduct = changed.dataset.productUrl;
      let target = new URL(otherProduct || product.dataset.productUrl, location.origin);
      const currentQuery = new URL(location.href).searchParams;
      if (currentQuery.has('preview_theme_id'))
        target.searchParams.set('preview_theme_id', currentQuery.get('preview_theme_id'));
      if (selected.length) target.searchParams.set('option_values', selected.join(','));
      const plan = $('[data-selling-plan]', buy)?.value;
      if (plan) target.searchParams.set('selling_plan', plan);
      if (
        target.origin !== location.origin ||
        target.pathname !== new URL(product.dataset.productUrl, location.origin).pathname
      ) {
        location.assign(target.href);
        return;
      }
      abort?.abort();
      abort = new AbortController();
      const requestGeneration = ++generation;
      const requestUrl = new URL(target);
      requestUrl.searchParams.set('section_id', product.dataset.sectionId);
      state.busy = true;
      buy.setAttribute('aria-busy', 'true');
      $$('[data-add-to-cart]', buy).forEach((button) => {
        button.disabled = true;
      });
      const id = $('[name="id"]', buy);
      if (id) id.disabled = true;
      updateSticky();
      try {
        const response = await fetch(requestUrl, {
          signal: abort.signal,
          credentials: 'same-origin',
        });
        if (!response.ok) throw new Error('Variant request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = $('[data-product-buy]', doc);
        if (!fresh) throw new Error('Product information missing');
        if (requestGeneration !== generation || !product.isConnected) return;
        const freshQuantity = $('[name="quantity"]', fresh);
        if (freshQuantity) {
          const min = Number(freshQuantity.min || 1),
            max = Number(freshQuantity.max || Infinity),
            step = Number(freshQuantity.step || 1);
          freshQuantity.value = Math.min(
            max,
            Math.max(min, min + Math.floor((Number(quantity) - min) / step) * step),
          );
        }
        // Preserve app-added line item properties when an option refresh replaces the buying panel.
        const freshForm = $('[data-product-form]', fresh);
        $$('[name^="properties["]', buy).forEach((input) => {
          if (input.type === 'file') {
            freshForm?.append(input);
            return;
          }
          let replacement = $$('[name]', freshForm).find((node) => node.name === input.name);
          if (!replacement) {
            replacement = input.cloneNode(true);
            freshForm?.append(replacement);
          }
          replacement.value = input.value;
          if ('checked' in input) replacement.checked = input.checked;
        });
        buy.replaceWith(fresh);
        state.busy = false;
        const variantId = fresh.dataset.variantId;
        if (variantId) {
          target.searchParams.delete('option_values');
          target.searchParams.set('variant', variantId);
        }
        history.replaceState({}, '', target);
        const mediaId = fresh.dataset.featuredMedia;
        if (mediaId)
          galleryControllers.get($('[data-product-gallery]', product))?.showMedia(mediaId);
        const freshSpec = $('.specification-table', doc),
          currentSpec = $('.specification-table', product);
        if (freshSpec && currentSpec) currentSpec.replaceWith(freshSpec);
        const focus = document.getElementById(focusId);
        focus?.focus({ preventScroll: true });
        announce(
          `${$('.current-price', fresh)?.textContent || 'Unavailable'}. ${$('.availability', fresh)?.textContent.trim() || ''}`,
        );
        updateSticky();
        document.dispatchEvent(
          new CustomEvent('bbs:variant:change', { detail: { variantId, product } }),
        );
      } catch (error) {
        if (error.name === 'AbortError' || requestGeneration !== generation) return;
        state.busy = false;
        buy.removeAttribute('aria-busy');
        // The old variant stays disabled: an unconfirmed option must never buy the previous selection.
        showError(
          $('[data-product-error]', buy),
          'We couldn’t load that selection. Choose an option again or reload the page.',
        );
        updateSticky();
      }
    });
  }

  function money(cents) {
    const currency = window.Shopify?.currency?.active || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency,
      }).format(Number(cents) / 100);
    } catch (_) {
      return `${(Number(cents) / 100).toFixed(2)} ${currency}`;
    }
  }
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = Number(count) === 0;
    });
    const iframe = document.getElementById('bbsWordpressHeaderFrame');
    if (iframe) {
      try {
        iframe.contentWindow?.postMessage(
          { type: 'bbsShopifyCart', count: Number(count) },
          new URL(iframe.src).origin,
        );
      } catch (_) {}
    }
  }
  async function fetchDrawer() {
    const url = new URL(route('cart'), location.origin);
    url.searchParams.set('section_id', 'bbs-cart-drawer');
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Basket display unavailable');
    return response.text();
  }
  function replaceCartContents(html, sectionId) {
    if (!html || typeof html !== 'string') return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh =
      $(`[data-cart-content][data-section-id="${escapeSelector(sectionId)}"]`, doc) ||
      $('[data-cart-content]', doc);
    const current = $(`[data-cart-content][data-section-id="${escapeSelector(sectionId)}"]`);
    if (!fresh || !current) return false;
    const note = $('[name="note"]', current),
      openNote = $('.cart-note', current)?.open;
    const freshNote = $('[name="note"]', fresh);
    if (note && freshNote) freshNote.value = note.value;
    if (openNote && $('.cart-note', fresh)) $('.cart-note', fresh).open = true;
    current.replaceWith(fresh);
    updateCartCount(fresh.dataset.itemCount);
    return true;
  }
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-cart-open]');
    if (
      !link ||
      document.body.dataset.cartType !== 'drawer' ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    event.preventDefault();
    openDialog(document.getElementById('CartDrawer'), link);
    try {
      replaceCartContents(await fetchDrawer(), 'bbs-cart-drawer');
    } catch (_) {
      announce('Your basket could not refresh. Open the full basket to check its contents.');
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || document.body.dataset.cartType !== 'drawer') return;
    event.preventDefault();
    const product = form.closest('[data-bbs-product]'),
      state = productControllers.get(product),
      button = $('[data-add-to-cart]', form);
    if (button?.disabled || state?.busy || cartBusy || !form.reportValidity()) return;
    const errorNode = $('[data-product-error]', form),
      original = button.innerHTML;
    if (errorNode) errorNode.hidden = true;
    cartBusy = true;
    button.disabled = true;
    button.textContent = 'Adding…';
    state?.updateSticky();
    let added = false;
    try {
      const payload = new FormData(form);
      payload.append('sections', 'bbs-cart-drawer');
      payload.append('sections_url', route('cart'));
      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        body: payload,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const result = await response.json();
      if (!response.ok || result.status)
        throw new Error(result.description || result.message || 'This item could not be added.');
      added = true;
      const html = result.sections?.['bbs-cart-drawer'] || (await fetchDrawer());
      if (!replaceCartContents(html, 'bbs-cart-drawer'))
        throw new Error('Basket display unavailable');
      announce('Added to your basket.');
      openDialog(document.getElementById('CartDrawer'), button);
      document.dispatchEvent(new CustomEvent('bbs:cart:change'));
    } catch (error) {
      if (added) {
        showError(errorNode, 'Added to your basket. Open the full basket to review it.');
        const link = document.createElement('a');
        link.href = route('cart');
        link.textContent = ' View basket';
        link.className = 'text-link';
        errorNode?.append(link);
      } else {
        showError(
          errorNode,
          error instanceof TypeError
            ? 'We couldn’t confirm the addition. Check your basket before trying again.'
            : error.message,
        );
      }
    } finally {
      cartBusy = false;
      if (button.isConnected) {
        button.innerHTML = original;
        button.disabled = $('[data-product-buy]', product)?.dataset.available !== 'true';
        state?.updateSticky();
      }
    }
  });
  async function changeCart(trigger, quantity) {
    const content = trigger.closest('[data-cart-content]'),
      form = $('[data-cart-form]', content),
      key = trigger.dataset.lineKey;
    if (!content || !key || cartBusy) return;
    const field = trigger.matches('input') ? trigger : null;
    if (field && !field.reportValidity()) return;
    cartBusy = true;
    form.setAttribute('aria-busy', 'true');
    const errorNode = $('[data-cart-error]', content);
    if (errorNode) errorNode.hidden = true;
    $$('button,input,textarea', form).forEach((node) => {
      node.disabled = true;
    });
    const sectionId = content.dataset.sectionId;
    const sections = Array.from(new Set([sectionId, 'bbs-cart-drawer']));
    try {
      const response = await fetch(route('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections, sections_url: route('cart') }),
      });
      const result = await response.json();
      if (!response.ok || result.status)
        throw new Error(result.description || result.message || 'Unable to update this quantity.');
      let currentReplaced = false;
      for (const id of sections) {
        const replaced = replaceCartContents(result.sections?.[id], id);
        if (id === sectionId) currentReplaced = replaced;
      }
      updateCartCount(result.item_count);
      if (!currentReplaced) {
        location.assign(route('cart'));
        return;
      }
      const next = $(`[data-cart-content][data-section-id="${escapeSelector(sectionId)}"]`);
      const nextQuantity = $(`[data-cart-quantity][data-line-key="${escapeSelector(key)}"]`, next);
      if (nextQuantity) nextQuantity.focus({ preventScroll: true });
      else $('[name="checkout"]', next)?.focus({ preventScroll: true });
      announce(quantity === 0 ? 'Item removed from your basket.' : 'Basket updated.');
    } catch (error) {
      showError(
        errorNode,
        error instanceof TypeError
          ? 'We couldn’t confirm the update. Open the full basket before trying again.'
          : error.message,
      );
    } finally {
      cartBusy = false;
      if (form.isConnected) {
        form.removeAttribute('aria-busy');
        $$('button,input,textarea', form).forEach((node) => {
          node.disabled = false;
        });
      }
    }
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-quantity]'))
      changeCart(event.target, Number(event.target.value));
  });
  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (remove && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
      changeCart(remove, 0);
    }
  });
  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-cart-form]') && cartBusy) event.preventDefault();
    if (
      event.target.matches('[data-product-form]') &&
      productControllers.get(event.target.closest('[data-bbs-product]'))?.busy
    )
      event.preventDefault();
  });

  function initPredictive(form) {
    if (initializedSearch.has(form)) return;
    initializedSearch.add(form);
    const input = $('[data-predictive-input]', form),
      list = $('[data-suggestions]', form);
    if (!input || !list) return;
    let timer,
      abort,
      selected = -1,
      generation = 0;
    function hide() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      selected = -1;
    }
    function highlight(index) {
      const links = $$('[role="option"]', list);
      if (!links.length) return;
      selected = (index + links.length) % links.length;
      links.forEach((link, i) => link.setAttribute('aria-selected', String(i === selected)));
      input.setAttribute('aria-activedescendant', links[selected].id);
      links[selected].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('input', () => {
      clearTimeout(timer);
      abort?.abort();
      const version = ++generation;
      const query = input.value.trim();
      if (query.length < 2) {
        hide();
        return;
      }
      timer = setTimeout(async () => {
        abort = new AbortController();
        const url = new URL(route('search/suggest.json'), location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        try {
          const response = await fetch(url, { signal: abort.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (version !== generation) return;
          list.replaceChildren();
          selected = -1;
          const products = data.resources?.results?.products || [];
          for (const [index, product] of products.entries()) {
            const link = document.createElement('a');
            link.href = product.url;
            link.setAttribute('role', 'option');
            link.setAttribute('aria-selected', 'false');
            link.id = `${list.id}-${index}`;
            const src = product.featured_image?.url || product.image;
            if (src) {
              const image = document.createElement('img');
              image.src = src;
              image.alt = '';
              image.width = 48;
              image.height = 48;
              link.append(image);
            }
            const text = document.createElement('span'),
              title = document.createElement('strong');
            title.textContent = product.title;
            text.append(title);
            if (product.price !== undefined) {
              const price = document.createElement('small');
              price.textContent = money(Number(product.price) * 100);
              text.append(price);
            }
            link.append(text);
            list.append(link);
          }
          const more = document.createElement('a'),
            search = new URL(form.action);
          search.searchParams.set('q', query);
          search.searchParams.set('type', 'product');
          more.href = search.href;
          more.className = 'search-view-all';
          more.textContent = `View all results for “${query}” →`;
          more.setAttribute('role', 'option');
          more.setAttribute('aria-selected', 'false');
          more.id = `${list.id}-all`;
          list.append(more);
          list.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          announce(`${products.length} product suggestions. Use arrow keys to explore.`);
        } catch (error) {
          if (error.name !== 'AbortError' && version === generation) hide();
        }
      }, 220);
    });
    input.addEventListener('keydown', (event) => {
      if (list.hidden) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        highlight(selected + (event.key === 'ArrowDown' ? 1 : -1));
      }
      if (event.key === 'Escape') hide();
      if (event.key === 'Enter' && selected >= 0) {
        event.preventDefault();
        $$('[role="option"]', list)[selected]?.click();
      }
    });
    form.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!form.contains(document.activeElement)) hide();
      }, 0);
    });
    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) hide();
    });
    form.addEventListener('submit', hide);
  }

  let catalogueAbort = null,
    catalogueVersion = 0;
  function syncFilters() {
    $$('[data-filter-dialog]').forEach((dialog) => {
      const mobile = window.matchMedia('(max-width: 1000px)').matches;
      if (dialog.dataset.mode === (mobile ? 'mobile' : 'desktop')) return;
      if (dialog.open && (mobile || dialog.matches(':modal'))) dialog.close();
      dialog.dataset.mode = mobile ? 'mobile' : 'desktop';
      if (!mobile) dialog.open = true;
      const hasFilters = $$('.facet', dialog).length > 0;
      const open = $('[data-filter-open]', dialog.closest('form'));
      if (open) open.hidden = !hasFilters;
    });
    if (window.matchMedia('(min-width: 1001px)').matches)
      closeDialog(document.getElementById('MobileMenu'));
  }
  window.addEventListener('resize', syncFilters);
  async function navigateCatalogue(url, push = true) {
    const current = $('[data-catalogue]');
    if (!current) {
      location.assign(url);
      return;
    }
    catalogueAbort?.abort();
    catalogueAbort = new AbortController();
    const version = ++catalogueVersion;
    const destination = new URL(url, location.href),
      request = new URL(destination);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) {
      destination.searchParams.set('preview_theme_id', preview);
      request.searchParams.set('preview_theme_id', preview);
    }
    request.searchParams.set('section_id', current.dataset.sectionId);
    $('[data-catalogue-form]', current)?.setAttribute('aria-busy', 'true');
    const modal = $('[data-filter-dialog]', current);
    if (modal?.matches(':modal')) closeDialog(modal);
    try {
      const response = await fetch(request, {
        signal: catalogueAbort.signal,
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('Results unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html'),
        fresh = $('[data-catalogue]', doc);
      if (!fresh) throw new Error('Results missing');
      if (version !== catalogueVersion) return;
      current.replaceWith(fresh);
      if (push) history.pushState({ bbsCatalogue: true }, '', destination);
      init(fresh);
      const toolbar = $('.catalogue-toolbar', fresh);
      if (toolbar) {
        toolbar.tabIndex = -1;
        toolbar.focus({ preventScroll: true });
        toolbar.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
      announce($('.results-count', fresh)?.textContent || 'Results updated.');
    } catch (error) {
      if (error.name === 'AbortError' || version !== catalogueVersion) return;
      $('[data-catalogue-form]', current)?.removeAttribute('aria-busy');
      const message = $('[data-catalogue-error]', current);
      showError(message, 'We couldn’t refresh the results. ');
      if (message) {
        const retry = document.createElement('a');
        retry.href = destination.href;
        retry.textContent = 'Load these results';
        retry.className = 'text-link';
        message.append(retry);
      }
    }
  }
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-filter-open]');
    if (open) openDialog($('[data-filter-dialog]', open.closest('form')), open);
    const close = event.target.closest('[data-filter-close]');
    if (close) closeDialog(close.closest('dialog'));
    const link = event.target.closest('[data-catalogue-link]');
    if (
      link &&
      link.closest('[data-catalogue]') &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey
    ) {
      event.preventDefault();
      navigateCatalogue(link.href);
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-catalogue-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const url = new URL(form.action);
    const params = new URLSearchParams(new FormData(form));
    for (const [key, value] of [...params]) if (value === '') params.delete(key);
    url.search = params;
    navigateCatalogue(url);
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
  });
  window.addEventListener('popstate', () => {
    if ($('[data-catalogue]')) navigateCatalogue(location.href, false);
    else if ($('[data-bbs-product]')) location.reload();
  });

  function initRecommendations(node) {
    if (initializedRecommendations.has(node)) return;
    initializedRecommendations.add(node);
    const load = async () => {
      try {
        const url = new URL(node.dataset.url, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh?.querySelector('.product-card') && node.isConnected)
          node.replaceChildren(...fresh.childNodes);
      } catch (_) {
        /* Optional recommendations never obstruct a purchase. */
      }
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            load();
          }
        },
        { rootMargin: '400px' },
      );
      observer.observe(node);
    } else load();
  }
  function initAddresses(root) {
    $$('[data-address-country]', root).forEach((country) => {
      if (country.dataset.initialized) return;
      country.dataset.initialized = 'true';
      const form = country.closest('form'),
        province = $('[data-address-province]', form),
        container = $('[data-province-container]', form);
      const defaultCountry = country.dataset.default;
      const option = Array.from(country.options).find(
        (item) => item.value === defaultCountry || item.text === defaultCountry,
      );
      if (option) country.value = option.value;
      function update(first = false) {
        let list = [];
        try {
          list = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
        } catch (_) {}
        province.replaceChildren();
        list.forEach(([value, label]) => {
          const node = document.createElement('option');
          node.value = value;
          node.textContent = label;
          province.append(node);
        });
        container.hidden = list.length === 0;
        province.disabled = list.length === 0;
        if (first && province.dataset.default) {
          const selected = Array.from(province.options).find(
            (item) =>
              item.value === province.dataset.default || item.text === province.dataset.default,
          );
          if (selected) province.value = selected.value;
        }
      }
      country.addEventListener('change', () => update());
      update(true);
    });
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-open-recovery]')) {
      const recovery = document.getElementById('recover');
      if (recovery) recovery.open = true;
    }
  });
  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-delete-address]') && !window.confirm('Delete this address?'))
      event.preventDefault();
  });
  function initIframe() {
    const iframe = document.getElementById('bbsWordpressHeaderFrame');
    if (!iframe) return;
    let origin;
    try {
      origin = new URL(iframe.src).origin;
    } catch (_) {
      return;
    }
    let normalHeight = window.innerWidth <= 1000 ? 166 : 194;
    function height(value) {
      const size = Number(value);
      if (!Number.isFinite(size) || size < 60 || size > 2000) return;
      iframe.style.height = `${Math.round(size)}px`;
      iframe.parentElement.style.height = `${Math.round(size)}px`;
    }
    window.addEventListener('message', (event) => {
      if (
        event.source !== iframe.contentWindow ||
        event.origin !== origin ||
        !event.data ||
        typeof event.data !== 'object'
      )
        return;
      if (event.data.type === 'bbsHeaderHeight') {
        height(event.data.height);
        if (Number(event.data.height) < 400) normalHeight = Number(event.data.height);
      }
      if (event.data.type === 'bbsMobileMenuOpen') height(760);
      if (event.data.type === 'bbsMobileMenuClosed') height(normalHeight);
      if (event.data.type === 'bbsRequestCartCount') refreshCount();
    });
    async function refreshCount() {
      try {
        const response = await fetch(route('cart.js'), { credentials: 'same-origin' });
        if (response.ok) updateCartCount((await response.json()).item_count);
      } catch (_) {}
    }
    iframe.addEventListener('load', refreshCount);
    refreshCount();
  }
  function init(root = document) {
    if (root.matches?.('[data-bbs-product]')) initProduct(root);
    $$('[data-product-gallery]', root).forEach(initGallery);
    $$('[data-bbs-product]', root).forEach(initProduct);
    $$('[data-search-form]', root).forEach(initPredictive);
    $$('[data-recommendations]', root).forEach(initRecommendations);
    initAddresses(root);
    syncFilters();
    $$('.logo-image', root).forEach((image) => {
      image.addEventListener('error', () => image.remove(), { once: true });
    });
    if (location.hash === '#recover' || $('#recover .errors, #recover [data-recovery-success]')) {
      const recovery = document.getElementById('recover');
      if (recovery) recovery.open = true;
    }
  }
  init();
  initIframe();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    $$('[data-product-gallery]', event.target).forEach((node) =>
      galleryControllers.get(node)?.pauseAll(),
    );
  });
  document.addEventListener('shopify:block:select', (event) => {
    event.target.scrollIntoView({ block: 'center' });
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted)
      fetch(route('cart.js'))
        .then((response) => response.json())
        .then((cart) => updateCartCount(cart.item_count))
        .catch(() => {});
  });
})();
